import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import { ChangeRequestStatus, ClaimRequestFiat, CountForAdminPack, GetFaitEvenue, Notifcation, PackBuyerCount, PackBuyerssList, RevenueAnnual } from '../../actions/users';
import { toastAlert } from '../../lib/toastAlert';
import { useSelector } from 'react-redux';
import ReactDatatable from "@ashvin27/react-datatable";
import $ from "jquery";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import PayModal from '../../Components/Modals/Revenue/PayModal';
import { Navigate, useNavigate } from 'react-router-dom';

const initialFormValue = {
  PackName: "",
  displayName: "",
  ShortDiscription: "",
  Discrption: "",
  ERC: false,
  Soulbound: false,
  Bulkminting: false,
  file: "",
  filename: "",
  Price: "",
  address: "",
  _id: "",
  Currency: "",
  units1: [],
  units1price: [],
  RangeAndPrice: [],
  TokenScanner: false,
  DashBoardAndProfile: false,
  DomainCampaign: false,
  Country: "",
};

const initialProduct = {
  ProductName: "",
  DisplayName: "",
  ProductDiscription: "",
  Country: "",
  ProductCurrency: "",
  file: "",
  filename: "",
  PlanSelected: [],
};

const Revenue = () => {
  const Wallet_Details = useSelector((state) => state.wallet_connect_context);
  const [responsive, setresponsive] = useState(true);
  const [PackDetails, SetPackDetails] = useState([]);
  const [BuyerrsCount, SetBuyCount] = useState({});
  const [SubcriberCount, SetSubcriberCount] = useState("");
  const [NewSub, setNewSub] = useState();
  const [Notification, SetNotification] = useState([]);

  const [formValue, setFormValue] = useState(initialFormValue);
  const [Plans, SetPlans] = useState([]);
  const [Product, SetProduct] = useState([]);
  const [Counttt, SetCountt] = useState({});
  const [validateError, setValidateError] = useState({});
  const [AddTire, setAddTire] = useState({});
  const [Revenuee, SetRevenue] = useState(0);
  const [PlanShowTable, SetPlanShowTable] = useState([])

  const [Royalty, SetRoyalty] = useState(0)
  const [Price, SetPrice] = useState(0)
  const [TotalAmount, SetTotalAmount] = useState(0)
  const [TotalUserClaimed, SetTotalUserClaimed] = useState()
  const [Balance, SetBalance] = useState()
  const [App_Btn, SetApp_Btn] = useState("Start")
  const [Transcation, SetTransCation] = useState({})
  const [ProcessStatus, SetProcess] = useState("Start")

  const [payModal, setPayModal] = useState(false)

  useEffect(() => {
    GetRevenueFiat();
    FaitRequest();
  }, []);

  const GetRevenueFiat = async () => {
    var plans = await GetFaitEvenue();
    if (plans.Message.length) {
      SetPlans(plans.Message);
      RoyaltyAndPrice(plans.Message)
    }
  };

  const FaitRequest = async () => {
    var plans = await ClaimRequestFiat();
    if (plans.Details.length) {
      SetProduct(plans.Details);
      RoyaltyAndPrice1(plans.Details)
    }
  };

  useEffect(() => {
    PackBuyerList();
    BuyCount();
    NotifcationSend();
    SubScriberLsit();
    RevenueAnnualSet();
    AdminPurchseCount();
  }, []);

  const PackBuyerList = async () => {
    var test = await PackBuyerssList();
    if (test.Message == "success") {
      SetSubcriberCount(test.ListingBuyers.length);
    } else {
    }
  };

  const BuyCount = async () => {
    var Count = await PackBuyerCount();
    if (Count.data.Message == "success") {
      SetPackDetails(Count.data.PackDetail);
      SetBuyCount(Count.data.BuyersCount);
    } else {
      toastAlert("error", "error in server");
    }
  };

  const NotifcationSend = async () => {
    var Count = await Notifcation();
    if (Count.data.Message == "success") {
      SetNotification(Count.data.userValue);
    } else {
      toastAlert("error", "error in server");
    }
  };

  const SubScriberLsit = async () => {
    var test = await PackBuyerssList();
    if (test.Message == "success") {
      setNewSub(test.ListingBuyers);
    } else {
    }
  };

  const RevenueAnnualSet = async () => {
    var returnData = await RevenueAnnual();
    SetRevenue(returnData?.data?.revenue[0]?.sum);
  };

  const AdminPurchseCount = async () => {
    var testtt = await CountForAdminPack();
    if (testtt.data.Success == true) {

      var val = []
      let starter_len = testtt?.data?.revenue?.filter((item) => item._id == "Starter")
      if (starter_len.length > 0) val.push(starter_len[0])
      else val.push({ _id: "Starter", lastSalesDate: 0 })

      let prof_len = testtt?.data?.revenue?.filter((item) => item._id == "Professional")
      if (prof_len.length > 0) val.push(prof_len[0])
      else val.push({ _id: "Professional", lastSalesDate: 0 })

      let Agency_len = testtt?.data?.revenue?.filter((item) => item._id == "Agency")
      if (Agency_len.length > 0) val.push(Agency_len[0])
      else val.push({ _id: "Agency", lastSalesDate: 0 })

      SetCountt(val)

    }
  };

  const RoyaltyAndPrice = async (FiatRv) => {
    if (FiatRv.length > 0) {
      var MapAndReduceRoyalty = FiatRv.map((item, index) => {
        var TotalRoyalty = Number(item.YourRoyaltyPercent)
        return TotalRoyalty
      }).reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
      var MapAndReducePrice = FiatRv.map((item, index) => {
        var TotalPrice = Number(item.YouSplitPercent)
        return TotalPrice
      }).reduce((partialSum, a) => Number(partialSum) + Number(a), 0)

      var TotalAmount = MapAndReducePrice + MapAndReduceRoyalty
      var RequestCompleted = FiatRv.map((item, index) => {
        return Number(item.NFTPriceWithSerice)
      }).reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
      var BalanceLeftToClaim = TotalAmount
      SetPrice(MapAndReducePrice)
      SetTotalAmount(TotalAmount)
      SetBalance(BalanceLeftToClaim)
      SetTotalUserClaimed(RequestCompleted)
    }
  }

  const RoyaltyAndPrice1 = async (FiatRv) => {
    if (FiatRv.length > 0) {
      var TotalAmountSend = FiatRv.map((item, index) => {
        return item.Status == "completed" && item.ClaimAmount
      }).reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
      var TotalAmountBalane = FiatRv.map((item, index) => {
        return item.Status == "Pending" && item.ClaimAmount ? item.ClaimAmount : 0
      }).reduce((partialSum, a) => Number(partialSum) + Number(a), 0)
      SetRoyalty(TotalAmountSend)
      SetBalance(TotalAmountBalane)
    }
  }

  const ClickShowPlans = async (data) => {
    if (data.Status == "Pending") {
      setPayModal(true)
      SetPlanShowTable(data)
    } else {
      toastAlert("success", "You Already Paid to this User")
    }
  };

  function pageChange(pageData) {
  }

  const ErrClears = () => {
    setValidateError({})
    setFormValue(initialFormValue);
    var formdata = {}
    setAddTire(formdata)
  }

  const DBsavePackBuy = async (data, PaypalstateRe) => {
    const reqdata = {
      Transcation: data,
      Paypalstate: PaypalstateRe,
    }
    SetProcess("Processing")
    var PurchasedData = await ChangeRequestStatus(reqdata);
    if (PurchasedData.Status) {
      SetProcess("Done")
      toastAlert("success", PurchasedData.Message)
      setPayModal(true)
      window.location.reload()
    } else {
      toastAlert("error", PurchasedData.Message)
      SetProcess("Try Again")
    }
  }

  const configdata = {
    page_size: 5,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No user found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: <> Previous </>,
        next: <>Next</>,
        last: "Last",
      },
    },
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
    defaultSortAsc: true,
  };

  const columns = [
    {
      key: "Address",
      text: "User Address",
      className: "Address",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.Address}</p>,
    },
    {
      key: "tokenID",
      text: "tokenID",
      className: "Address",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.tokenID}</p>,
    },
    {
      key: "NFTPrice",
      text: "NFT Amount",
      className: "Currency",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.NFTPrice}</p>,
    },

    {
      key: "RoyaltyAmount",
      text: "Royalty percent",
      className: "Price",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.RoyaltyAmount}</p>,
    },
    {
      key: "RoyaltyAmount",
      text: "Royalty percent",
      className: "Price",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.RoyaltyAmount}</p>,
    },
    {
      key: "SplitAmount",
      text: "Split Amount",
      className: "displayName",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.SplitAmount}</p>,
    },
    {
      key: "YouSplitPercent",
      text: "You Split Percent",
      className: "displayName",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.YouSplitPercent}</p>,
    },
    {
      key: "YouSplitPercent",
      text: "Your Claim Amount",
      className: "displayName",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.YouSplitPercent}</p>,
    },
    {
      key: "Date",
      text: "Pruchased Time",
      className: "CreateTime",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.Date}</p>,
    },
  ];

  const columnsProduct = [
    {
      key: "Address",
      text: "User Address",
      className: "ProductName",
      align: "center",
      sortable: false,
      //cell: (row, index, column, id) => <p>{index + 1}</p>,
      cell: (record) => <p className='text-center exchange_table_values'>{record.Address}</p>,
    },

    {
      key: "ClaimAmount",
      text: "Amount Requested",
      className: "DisplayName",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.ClaimAmount}</p>,
    },

    {
      key: "paypalId",
      text: "paypal Id",
      className: "ProductCurrency",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.paypalId}</p>,
    },
    {
      key: "Status",
      text: "Status",
      className: "Plans",
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.Status}</p>,
    },
    {
      key: "Date",
      text: "Request Raised Time",
      className: "CreateTime",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.Date}</p>,
    },
    {
      key: "UpdatedDate",
      text: "UpdatedDate",
      className: "CreateTime",
      width: 100,
      align: "center",
      sortable: false,
      cell: (record) => <p className='text-center exchange_table_values'>{record.UpdatedDate}</p>,
    },
    {
      key: "createdAt",
      text: "Change date",
      className: "Date",
      align: "center",
      sortable: false,
      cell: (record) => (
        <div className='text-center exchange_table_values'>
          <p className="subs_tbl_plan_txt plans_color" onClick={() => ClickShowPlans(record)}> {record.Status == "completed" ? "Paid" : "Pay"}</p>
        </div>
      ),
    },
  ];

  return (
    <>
      {payModal &&
        <PayModal
          onDismiss={() => setPayModal(false)}
          PlanShowTable={PlanShowTable}
          Wallet_Details={Wallet_Details}
          App_Btn={App_Btn}
          SetApp_Btn={SetApp_Btn}
          DBsavePackBuy={DBsavePackBuy}
          SetTransCation={SetTransCation}
        />}
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={'Revenue'} />
            <div className='common_page_scroller mt-5 pe-2'>

              <div>
                <div className="topcardsecs">
                  <div className="mt-2">
                    <div className="card  blackcard_style  mb-1">
                      <div className="firstrow">
                        <div>
                          <i class="fa fa-circle admint_nrm_round admin_green_round mb-2" />
                        </div>
                        <div className="div_text">Tickets Raised</div>
                      </div>

                      <div className="graph_align">
                        <div className="count_dtls">
                          <span className="admint_count_txt mb-0">{Product.length}</span>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="mt-2">
                    <>

                      <div className="card five_div_card  blackcard_style mb-1">
                        <div className="firstrow">
                          <div>
                            <i class="fa fa-circle admint_nrm_round admin_red_round mb-2"></i>
                          </div>
                          <span className="div_text">Amount Recived</span>
                        </div>

                        <div className="graph_align">
                          <div className="count_dtls">
                            <p className='admint_count_txt mb-0'>{Price} $</p>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>

                  <div className="mt-2">
                    <>

                      <div className="card five_div_card blackcard_style mb-1">
                        <div className="firstrow">
                          <div>
                            <i class="fa fa-circle admint_nrm_round admin_red_round mb-2"></i>
                          </div>
                          <span className="div_text">Amount Sent</span>
                        </div>

                        <div className="graph_align">
                          <div className="count_dtls">

                            <p className='admint_count_txt mb-0'>{Royalty}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>

                  <div className="mt-2">
                    <>

                      <div className="card five_div_card blackcard_style  mb-1">
                        <div className="firstrow">
                          <div>
                            <i class="fa fa-circle admint_nrm_round admin_red_round mb-2"></i>
                          </div>
                          <span className="div_text">balance Amount</span>
                        </div>

                        <div className="graph_align">
                          <div className="count_dtls">

                            <br />
                            <p className='admint_count_txt mb-0'>{Balance ? Balance : 0}</p>

                          </div>
                        </div>
                      </div>
                    </>
                  </div>

                  <div className="mt-2">
                    <div className="card five_div_card blackcard_style mb-1">
                      <div className="firstrow">
                        <div>
                          <i class="fa fa-circle admint_nrm_round admin_sandal_round mb-2"></i>
                        </div>
                        <div className="div_text">Total Revenue (includes service fee)</div>
                      </div>

                      <div className="graph_align">
                        <div className="count_dtls">

                          <span className="admint_count_txt mb-0">{" $ " + TotalUserClaimed == undefined ? TotalUserClaimed : 0}</span>

                          <br />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Plans Tablesssss */}

            <Row>
              <Col sm={12} xl={12} className='mt-4'>
                <div className="mt-3">
                  <div className="w-100 themetable">
                    <ReactDatatable
                      responsive={responsive}
                      className="table table-striped table-responsive  react_table_border_align themetable"
                      config={configdata}
                      records={Plans}
                      columns={columns}
                      onPageChange={pageChange()}
                    />
                  </div>
                </div>
              </Col>
              <Col sm={12} xl={12} className='mt-4'>
                <div className="mt-3">
                  <div className="w-100 themetable">
                    <ReactDatatable
                      responsive={responsive}
                      className="table table-striped table-responsive react_table_border_align themetable"
                      config={configdata}
                      records={Product}
                      columns={columnsProduct}
                      onPageChange={pageChange()}
                    />
                  </div>
                </div>
              </Col>
            </Row>


        

          

            {/* Add Product Model */}
            <div
              class="modal fade newthememodal"
              id="addproduct"
              data-backdrop="static"
              data-keyboard="false"
              tabindex="-1"
              aria-labelledby="staticBackdropLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog  modal-dialog-scrollable modal-md">
                <div class="modal-content">
                  <div class="modal-header edituser_modal_body_align">
                    <h5
                      class="modal-title edit_header_title_align"
                      id="staticBackdropLabel"
                    >
                      CheckOut
                    </h5>
                    <button
                      type="button"
                      class="close modal_cls_btn_align"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => ErrClears()}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body edituser_modal_body_align">
                    <div className="">
                      <div className="row mx-0">
                        <div className="col-12 col-md-6 px-4">
                          <p className="buy_title_sm text-md-right">User Address</p>
                          <p className="buy_title_md text-md-right">{(PlanShowTable?.Address)?.slice(0, 20)}</p>
                        </div>
                      </div>
                      <div className="row mx-0 pb-3">
                        <div className="col-12 col-sm-6 px-4">
                          <p className="buy_desc_sm">Price of the NFT</p>
                        </div>
                        <div className="col-12 col-sm-6 px-4 text-sm-right">
                          <p className="buy_desc_sm_bold">{PlanShowTable?.ClaimAmount} {"Fait"}</p>
                        </div>
                      </div>
                      <PayPalScriptProvider options={{
                        "client-id": "AbTqUJD-BNLtugG9ywILf_SQuoQ2J0GQmLOAqKEpAh__8pXjH1NSSzflZvE6nepog4wo3KRP4ULHrJhZ"
                      }}>
                        <PayPalButtons
                          style={{ layout: "vertical" }}
                          disabled={App_Btn == "Done" ? true : false}
                          forceReRender={[PlanShowTable]}

                          createOrder={(data, actions) => {
                            SetApp_Btn("process")
                            return actions.order
                              .create({
                                purchase_units: [
                                  {
                                    amount: {
                                      currency_code: "USD",
                                      value: PlanShowTable?.ClaimAmount,
                                    },
                                    payee: {
                                      email_address: PlanShowTable?.paypalId,
                                    },

                                  },
                                ],
                              })
                              .then((orderId) => {
                                return orderId;
                              });
                          }}
                          onApprove={(data, actions) => {
                            return actions.order.capture().then((details) => {
                              const Data = {
                                Buyername: details.payer.name.given_name,
                                Surname: details.payer.name.surname,
                                id: details.purchase_units[0].payments.captures[0].id,
                                TranscationId: details.id,
                                email_address: details.payer.email_address,
                                payer_id: details.payer.payer_id,
                                status: details.status,
                                Address: details.payer.address.country_code
                              }
                              SetApp_Btn("Done")
                              SetTransCation(Data)
                              DBsavePackBuy(Data, PlanShowTable)
                            });
                          }}
                          onError={(err) => {
                            SetApp_Btn("Try Again")
                            toastAlert("error", err);
                          }}

                        />
                      </PayPalScriptProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Revenue